import { render } from "./AddTask.vue?vue&type=template&id=3a292900&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=3a292900&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a292900"

export default script